import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axiosOriginal from 'axios';
import {
  Grid,
  InputLabel,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { useLocation } from 'react-router';
import ClearIcon from '@material-ui/icons/Clear';
import TextField from '../../../components/TextField';
import Button from '../../../components/Button';
import bytesToSize from '../../../utils/bytesToSize';
import countries from '../const';
import useStyles from '../styles';
import { createCompany, updateCompany } from '../../../requests/api/company';

const CompanyForm = ({
  reload,
  currentSelection,
  setCurrentOpen,
  setError,
  setSucc,
  update,
}) => {
  const styles = useStyles();
  const { t } = useTranslation();
  const [inputValues, setInputValues] = useState(currentSelection);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const handleClose = () => {
    setCurrentOpen(false);
  };

  const handleUpload = async () => {
    setLoading(true);
    const fileParts = file.name.split('.');
    const timestamp = Date.now();
    const fileName = location.pathname === '/administration' ? `${fileParts[0]}-${timestamp}`
      : `${fileParts[0]} ${timestamp}`;
    const uploadData = {
      fileName,
      fileType: file.type,
    };
    const response = await axiosOriginal.post('/api/companies/signS3', uploadData);
    const options = {
      headers: {
        'Content-Type': file.type,
        'Content-Disposition': 'attachment',
      },
    };
    const { returnData } = response.data.data;
    const { signedRequest } = returnData;
    try {
      const uploadResponse = await axiosOriginal.put(
        signedRequest,
        file,
        options,
      );
      if (uploadResponse.status === 200) {
        const fileUrl = uploadResponse.config.url.split('?')[0];
        setError('');
        setLoading(false);
        return fileUrl;
      }
    } catch (err) {
      setError(t('administration.company.imageError'));
      return (err);
    }
    return (false);
  };

  const handleSelect = ({ target }) => {
    setFile(target.files[0]);
    setError('');
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setInputValues({
      ...inputValues,
      [id]: value,
    });
  };

  const selectCountry = (e) => {
    const { value } = e.target;
    setInputValues({
      ...inputValues,
      countryCode: value,
    });
  };

  const uploaderRender = () => {
    if (file) {
      return (
        <Grid
        container
        item
        justifyContent='flex-end'
        direction='row'
        xs={12}
        >
          <Grid
          container
          item
          justifyContent='flex-end'
          direction='row'
          alignItems='center'
          xs={8}
          >
            <Grid item xs={12}>
              <Typography variant="body1">
                {file.name}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2">
                {bytesToSize(file.size)}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs>
          <div className={styles.actions}>
            {loading ? (<CircularProgress />)
              : <ClearIcon onClick={() => setFile(null)} className={styles.uploadIcon} fontSize='large'/>
            }
          </div>
          </Grid>
        </Grid>
      );
    } return (
            <Grid
            container
            item
            justifyContent='flex-start'
            direction='row-reverse'
            xs={12}
            >
              <input
                className={styles.input}
                id="contained-button-file"
                accept='.jpg, .png, .jpeg'
                multiple
                type="file"
                onChange={handleSelect}
              />
              <label className={styles.uploadIcon} htmlFor="contained-button-file">
                      <CloudUploadIcon fontSize='large'/>
              </label>
         </Grid>
    );
  };

  const handleSend = async () => {
    let response;
    const url = await (file && handleUpload(file));
    if (update) {
      if (url) {
        response = await updateCompany({
          ...inputValues,
          logoUrl: url,
        });
      } else {
        response = await updateCompany(inputValues);
      }
    } else {
      if ((Object.values(inputValues).some((value) => value === '')) || !url) {
        setError(t('administration.validation'));
        return;
      }
      response = await createCompany({
        ...inputValues,
        logoUrl: url,
      });
    }
    if (response.success) {
      setSucc(t('administration.success'));
      handleClose();
      reload();
    } else {
      setError(t('administration.error'));
      handleClose();
      reload();
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSend();
    }
  };
  return (
        <div>
            <div className={styles.formWrapper}>
              <Grid container spacing={2} alignItems='flex-end'>
                <Grid item xs={12}>
                  <InputLabel variant='h4'>{t('administration.company.formName')}</InputLabel>
                  <TextField
                    variant="outlined"
                    id="name"
                    value={inputValues.name}
                    onChange={handleChange}
                    fullWidth
                  />
                  </Grid>
                  <Grid item xs={6}>
                  <InputLabel>{t('administration.company.formCountry')}</InputLabel>
                    <TextField
                    id="countryCode"
                    type="text"
                    variant="outlined"
                    value={inputValues.countryCode}
                    onChange={selectCountry}
                    select={true}
                    options = {countries}
                    fullWidth
                    InputProps={{
                      onKeyDown: handleKeyDown,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <InputLabel>{t('administration.company.formTax')}</InputLabel>
                  <TextField
                    id="taxId"
                    type="text"
                    variant="outlined"
                    value={inputValues.taxId}
                    onChange={handleChange}
                    fullWidth
                    InputProps={{
                      onKeyDown: handleKeyDown,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <InputLabel>{t('administration.company.formWhatsappLink')}</InputLabel>
                  <TextField
                    id="whatsappLink"
                    type="text"
                    variant="outlined"
                    value={inputValues.whatsappLink}
                    onChange={handleChange}
                    fullWidth
                    InputProps={{
                      onKeyDown: handleKeyDown,
                    }}
                  />
                </Grid>
                <Grid item xs= {8}>
                  {uploaderRender()}
                </Grid>
                <Grid item xs={4}>
                <Button
                  id="submit-ticket-btn"
                  onClick={handleSend}
                  variant="contained"
                  text={update ? t('administration.buttons.update') : t('administration.buttons.create')}
                  height="35px"
                  width="100%"
                  backgroundColor="theme-custom-solidButtonBackground"
                  color="theme-custom-solidButtonText"
                  borderRadius="10px"
                />
                </Grid>
                </Grid>
              </div>
        </div>
  );
};

export default CompanyForm;
